<template>
  <div>
    <b-button-group size="sm">
      <!-- <b-button variant="success" @click="edit(rowData.id)">Edit</b-button> -->
      <router-link :to="{name: 'Edit Config', params: { id: rowData.id }}" class="btn btn-primary"><i class="fa fa-cogs" title='Manage'></i></router-link>
    </b-button-group>    
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  Vue.use(VueSweetalert2)
  export default {
    name:'configs-actions',
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {      
      edit(id){
        this.$swal('Edit', 'Edit Config '+ id, 'success')
        // this.$parent.toggleDetailRow(id);
      },
    },    
  }
</script>